import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=f9f0fd52&scoped=true&"
import script from "./PageMenu.vue?vue&type=script&lang=js&"
export * from "./PageMenu.vue?vue&type=script&lang=js&"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=f9f0fd52&lang=scss&scoped=true&"
import style1 from "./PageMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f0fd52",
  null
  
)

export default component.exports